import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sip"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7.5 21H3L3.07202 16.5L13.7602 5.76025L18.25 10.25L7.5 21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.7523 3.75805C16.9925 2.51181 19.009 2.50938 20.2522 3.75264C21.4934 4.99378 21.4934 7.00608 20.2522 8.24722L18.2495 10.2499L13.7598 5.76016L15.7523 3.75805Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 4.99993L19 10.9999M3.07202 16.4999L15.7527 3.75805C16.993 2.51181 19.0094 2.50938 20.2527 3.75264C21.4939 4.99378 21.4939 7.00608 20.2527 8.24722L7.5 20.9999H3L3.07202 16.4999Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Sip = Vue.extend<IconProps>({
  name: 'SipIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'sip',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Sip;
